import { AppActions } from '../Actions';

const initialState = {
  appVersion: "v1.0.0",
  developerMode: "disable",
  player: "",
  game: "",
  openPages: ["/not-found","/","/admin/console","/about","/privacypolicy"],
  login: "/",
  home: "/home",
  language: (localStorage.getItem('almhulttamilsangam_language')||'ta').toLowerCase(),
  openPopup: '',
  showProgressBar: false,
  pageState: 100,
  errorCode: null,
  messages: [],
  localProgress: [],
  inagurationStatus: null,
  inagurationUserCount: 0,
  contactUs: {},
  journalSubMenu:[]
}

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case AppActions.LOAD: {
      return {
        ...state,
        ...action.payload
      };
    }
    case AppActions.ERROR: {
      return {
        ...state,
        errorCode: action.payload
      };
    }
    case AppActions.ERROR_ALERT: {
      return {
        ...state,
        error_alert: action.payload
      };
    }
    case AppActions.RESET_ERR: {
      return {
        ...state,
        errorCode: { response: '', request: '' } 
      };
    }
    case AppActions.SHOW_PB: {
      return {
        ...state,
        showProgressBar: true
      };
    }
    case AppActions.HIDE_PB: {
      return {
        ...state,
        showProgressBar: false
      };
    }
    case AppActions.POPUP: {
      return {
        ...state,
        openPopup: state.openPopup === action.payload ? '' : action.payload,
        errorCode: { response: '', request: '' },
        failmessage: ''
      };
    }
    case AppActions.LANG: {
      localStorage.setItem('almhulttamilsangam_language', action.payload);
      return {
        ...state,
        language: action.payload
      };
    }
    case AppActions.REG_FAIL: {
        return {
            ...state,
            failmessage: action.payload
        };
    }
    case AppActions.INAGURATE: {
        return {
            ...state,
            inagurationStatus: action.payload
        };
    }
    case AppActions.INAGURATE_USER: {
        return {
            ...state,
            inagurationUserCount: action.payload
        };
    }
    case AppActions.DEV_MODE: {
        return {
            ...state,
            developerMode: action.payload
        };
    }
    case AppActions.JOURNAL_MENU: {
        return {
            ...state,
            journalSubMenu: action.payload
        };
    }
    default:
      return state;
  }
};
